import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ManagedServicesPage = lazy(() => import('../pages/managed-services/page'));
const RiskAssessmentPage = lazy(() => import('../pages/risk-assessment/page'));
const AwarenessTrainingPage = lazy(() => import('../pages/awareness-training/page'));
const ScheduleCallPage = lazy(() => import('../pages/schedule-call/page'));
const CompleteSecurityManagementPage = lazy(() => import('../pages/complete-security-management/page'));
const SecurityPoliciesManualPage = lazy(() => import('../pages/security-policies-manual/page'));
const PhishingSimulationPage = lazy(() => import('../pages/phishing-simulation/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const StateRequirementsPage = lazy(() => import('../pages/state-requirements/page'));
const OurStoryPage = lazy(() => import('../pages/our-story/page'));
const ReferralPartnersPage = lazy(() => import('../pages/referral-partners/page'));

// State Requirements Pages
const NewYorkRequirementsPage = lazy(() => import('../pages/state-requirements/new-york/page'));
const MichiganRequirementsPage = lazy(() => import('../pages/state-requirements/michigan/page'));
const NorthCarolinaRequirementsPage = lazy(() => import('../pages/state-requirements/north-carolina/page'));
const NorthDakotaRequirementsPage = lazy(() => import('../pages/state-requirements/north-dakota/page'));
const MassachusettsRequirementsPage = lazy(() => import('../pages/state-requirements/massachusetts/page'));
const OregonRequirementsPage = lazy(() => import('../pages/state-requirements/oregon/page'));
const WashingtonRequirementsPage = lazy(() => import('../pages/state-requirements/washington/page'));

// Knowledge Center Pages
const HumanFocusedThreatsPage = lazy(() => import('../pages/knowledge-center/human-focused-threats/page'));
const MalwareRansomwarePage = lazy(() => import('../pages/knowledge-center/malware-ransomware/page'));
const AccessIdentityRisksPage = lazy(() => import('../pages/knowledge-center/access-identity-risks/page'));
const ThirdPartySupplyChainPage = lazy(() => import('../pages/knowledge-center/third-party-supply-chain/page'));
const DataProtectionPage = lazy(() => import('../pages/knowledge-center/data-protection/page'));
const BusinessContinuityPage = lazy(() => import('../pages/knowledge-center/business-continuity/page'));

// Portal Pages
const PortalLoginPage = lazy(() => import('../pages/portal/login/page'));
const PortalSignupPage = lazy(() => import('../pages/portal/signup/page'));
const PortalForgotPasswordPage = lazy(() => import('../pages/portal/forgot-password/page'));
const PortalDashboardPage = lazy(() => import('../pages/portal/dashboard/page'));
const PortalBookingsPage = lazy(() => import('../pages/portal/bookings/page'));
const PortalNewBookingPage = lazy(() => import('../pages/portal/bookings/new/page'));
const PortalDocumentsPage = lazy(() => import('../pages/portal/documents/page'));
const PortalSupportPage = lazy(() => import('../pages/portal/support/page'));
const PortalNewTicketPage = lazy(() => import('../pages/portal/support/new/page'));
const PortalContactPage = lazy(() => import('../pages/portal/contact/page'));
const PortalSettingsPage = lazy(() => import('../pages/portal/settings/page'));

// Purchase Pages
const PurchaseRiskAssessmentPage = lazy(() => import('../pages/purchase/risk-assessment/page'));
const PurchaseManagedServicesPage = lazy(() => import('../pages/purchase/managed-services/page'));
const PurchasePhishingSimulationPage = lazy(() => import('../pages/purchase/phishing-simulation/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/managed-services',
    element: <ManagedServicesPage />
  },
  {
    path: '/risk-assessment',
    element: <RiskAssessmentPage />
  },
  {
    path: '/awareness-training',
    element: <AwarenessTrainingPage />
  },
  {
    path: '/complete-security-management',
    element: <CompleteSecurityManagementPage />
  },
  {
    path: '/security-policies-manual',
    element: <SecurityPoliciesManualPage />
  },
  {
    path: '/phishing-simulation',
    element: <PhishingSimulationPage />
  },
  {
    path: '/pricing',
    element: <PricingPage />
  },
  {
    path: '/schedule-call',
    element: <ScheduleCallPage />,
  },
  {
    path: '/state-requirements',
    element: <StateRequirementsPage />,
  },
  {
    path: '/state-requirements/new-york',
    element: <NewYorkRequirementsPage />,
  },
  {
    path: '/state-requirements/michigan',
    element: <MichiganRequirementsPage />,
  },
  {
    path: '/state-requirements/north-carolina',
    element: <NorthCarolinaRequirementsPage />,
  },
  {
    path: '/state-requirements/north-dakota',
    element: <NorthDakotaRequirementsPage />,
  },
  {
    path: '/state-requirements/massachusetts',
    element: <MassachusettsRequirementsPage />,
  },
  {
    path: '/state-requirements/oregon',
    element: <OregonRequirementsPage />,
  },
  {
    path: '/state-requirements/washington',
    element: <WashingtonRequirementsPage />,
  },
  {
    path: '/our-story',
    element: <OurStoryPage />,
  },
  {
    path: '/referral-partners',
    element: <ReferralPartnersPage />,
  },
  {
    path: '/knowledge-center/human-focused-threats',
    element: <HumanFocusedThreatsPage />,
  },
  {
    path: '/knowledge-center/malware-ransomware',
    element: <MalwareRansomwarePage />,
  },
  {
    path: '/knowledge-center/access-identity-risks',
    element: <AccessIdentityRisksPage />,
  },
  {
    path: '/knowledge-center/third-party-supply-chain',
    element: <ThirdPartySupplyChainPage />,
  },
  {
    path: '/knowledge-center/data-protection',
    element: <DataProtectionPage />,
  },
  {
    path: '/knowledge-center/business-continuity',
    element: <BusinessContinuityPage />,
  },
  // Portal Routes
  {
    path: '/portal/login',
    element: <PortalLoginPage />,
  },
  {
    path: '/portal/signup',
    element: <PortalSignupPage />,
  },
  {
    path: '/portal/forgot-password',
    element: <PortalForgotPasswordPage />,
  },
  {
    path: '/portal/dashboard',
    element: <PortalDashboardPage />,
  },
  {
    path: '/portal/bookings',
    element: <PortalBookingsPage />,
  },
  {
    path: '/portal/bookings/new',
    element: <PortalNewBookingPage />,
  },
  {
    path: '/portal/documents',
    element: <PortalDocumentsPage />,
  },
  {
    path: '/portal/support',
    element: <PortalSupportPage />,
  },
  {
    path: '/portal/support/new',
    element: <PortalNewTicketPage />,
  },
  {
    path: '/portal/contact',
    element: <PortalContactPage />,
  },
  {
    path: '/portal/settings',
    element: <PortalSettingsPage />,
  },
  {
    path: '/purchase/risk-assessment',
    element: <PurchaseRiskAssessmentPage />,
  },
  {
    path: '/purchase/managed-services',
    element: <PurchaseManagedServicesPage />,
  },
  {
    path: '/purchase/phishing-simulation',
    element: <PurchasePhishingSimulationPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
